import React, { ComponentType } from 'react'
import { connect } from 'react-redux'
import { Header } from 'semantic-ui-react'
// Local
import { Encounter } from '../../authenticated/types'
import * as formatUtils from '../../common/formatUtils'
import CDIEncounterHeaderButtons from './cdiEncounterHeaderButtons'
import {
  ENCOUNTER,
  shouldRenderReskin2025
} from '../../../constant'
import { RootState } from '../../../store'

const SafeHeader = Header as unknown as ComponentType<any>

const mapStateToProps = (state: RootState) => ({
  currentUser: state.user
})

type ReduxStateProps = ReturnType<typeof mapStateToProps>

type Props = ReduxStateProps & {
  encounter: Encounter
  isACopiedEncounter: boolean
  onAction: (action: keyof typeof ENCOUNTER.ACTION) => void
}

function CdiEncounterHeader(
  props: Props
): JSX.Element | null {
  const {
    currentUser,
    encounter,
    isACopiedEncounter,
    onAction
  } = props

  const onClickHeaderButton = (
    action: keyof typeof ENCOUNTER.ACTION
  ): void => {
    if (onAction) onAction(action)
  }

  const className = shouldRenderReskin2025
    ? 'main-schedule-header reskin'
    : 'main-schedule-header'
  const date = formatUtils.formatEncounterHeaderDate(encounter.start)
  const patientName = formatUtils.formatPatientNameDob(encounter.patient)


  if (encounter) {
    return (
      <SafeHeader
        as="h4"
        attached="top"
        block
        className={ className }
      >
        <div className="time">
          { date }
        </div>
        <div className="name">
          { patientName }
        </div>
        <div className="header-arrows cdi">
          <CDIEncounterHeaderButtons
            encounter={ encounter }
            currentUser={ currentUser }
            isACopiedEncounter={ isACopiedEncounter }
            onClick={ onClickHeaderButton }
          />
        </div>
      </SafeHeader>
    )
  }
  return null
}

export default connect(mapStateToProps)(CdiEncounterHeader)
